import { AutogenModelCheckCallSchedLookup, AutogenRowCheckCallSchedLookup } from "./autogen/AutogenModelCheckCallSchedLookup";

export class ModelCheckCallSchedLookup extends AutogenModelCheckCallSchedLookup<RowCheckCallSchedLookup> {
	constructor() {
		super(RowCheckCallSchedLookup);
	}
}

export class RowCheckCallSchedLookup extends AutogenRowCheckCallSchedLookup {
}